import store from '../../store'
import $bus from '../eventbus.js'

$bus.on('error', function (err) {
  store.commit('addErrorLog', err)
})

window.addEventListener('error', function (e) {
  // ** cache error to log
  $bus.emit('error', e)
})